import { useRef } from "react";
import "./editorialForms.css";

export default function AudioForm({ data, onChange }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, audioFile: file, audioFileName: file.name });
    }
  };

  return (
    <div className="editorial_form audio_form">
      <div className="editorial_form_section">
        <label>
          Arquivo de Audio <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="audio/*,.mp3,.wav,.m4a,.ogg,.aac"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.audioFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z" />
              </svg>
              <span>{data.audioFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, audioFile: null, audioFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do audio</p>
              <span>MP3, WAV, M4A, OGG, AAC</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Tipo de Audio</label>
        <select
          value={data?.audioType || "voice_note"}
          onChange={(e) => onChange({ ...data, audioType: e.target.value })}
        >
          <option value="voice_note">Nota de Voz</option>
          <option value="sound_effect">Efeito Sonoro</option>
          <option value="ambient">Som Ambiente</option>
          <option value="narration">Narracao</option>
          <option value="interview">Entrevista</option>
          <option value="other">Outro</option>
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Titulo (opcional)</label>
        <input
          type="text"
          placeholder="De um titulo ao seu audio..."
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          maxLength={100}
        />
      </div>

      <div className="editorial_form_section">
        <label>Transcricao (opcional)</label>
        <textarea
          placeholder="Adicione uma transcricao do audio para acessibilidade..."
          value={data?.transcription || ""}
          onChange={(e) => onChange({ ...data, transcription: e.target.value })}
          rows={3}
        />
        <span className="editorial_form_hint">
          A transcricao ajuda pessoas com deficiencia auditiva
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Configuracoes</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="autoTranscribe"
            checked={data?.autoTranscribe || false}
            onChange={(e) =>
              onChange({ ...data, autoTranscribe: e.target.checked })
            }
          />
          <label htmlFor="autoTranscribe">
            Gerar transcricao automaticamente (IA)
          </label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="showWaveform"
            checked={data?.showWaveform !== false}
            onChange={(e) =>
              onChange({ ...data, showWaveform: e.target.checked })
            }
          />
          <label htmlFor="showWaveform">Mostrar forma de onda</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="allowDownload"
            checked={data?.allowDownload || false}
            onChange={(e) =>
              onChange({ ...data, allowDownload: e.target.checked })
            }
          />
          <label htmlFor="allowDownload">Permitir download</label>
        </div>
      </div>

      <div className="editorial_form_tip audio_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
        </svg>
        <span>
          Grave ou faca upload de um arquivo de audio. Formatos suportados: MP3,
          WAV, M4A, OGG (sem limite de tamanho).
        </span>
      </div>
    </div>
  );
}
